import mixpanel from "analytics/mixpanel";
import { Spin } from "antd";
import { useAuthDispatch } from "hooks/useAuth";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import {
  doLogoutError,
  doLogoutSuccess,
} from "./../../../store/auth/authentication";
import client from "../../../services/client";

interface LogoutProps extends RouteComponentProps {
  doLogoutSuccess: () => void;
  doLogoutError: () => void;
}

function Logout({ doLogoutSuccess, doLogoutError, history }: LogoutProps) {
  const authDispatch = useAuthDispatch();
  useEffect(() => {
    setTimeout(() => {
      localStorage.clear();
      window.location.href = '/';
    }, 1500);
    client
      .logout()
      .then(() => {
        mixpanel.track("Logout");
        authDispatch({ type: "logout success" });
        doLogoutSuccess();
        history.push("/login");
        window.location.reload();
      })
      .catch(() => doLogoutError());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="tw-h-screen tw-flex">
        <div className="tw-m-auto">
          <Spin />
        </div>
      </div>
    </div>
  );
}

const Routed = withRouter(Logout);
export default connect(null, { doLogoutSuccess, doLogoutError })(Routed);
